import { render, staticRenderFns } from "./SafetyCreate.vue?vue&type=template&id=b67f1320&scoped=true&"
import script from "./SafetyCreate.vue?vue&type=script&lang=js&"
export * from "./SafetyCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67f1320",
  null
  
)

export default component.exports